import { Routes } from '@angular/router';
import { authenticatedRouteGuards, canActivateCollaborators } from '@shared/guard/guard';
import { PageKey } from '@shared/services/page/models/page.key';

export const collaboratorRoute: Routes = [
  {
    path: 'collaborators',
    loadComponent: () => import('@collaborator/pages/list/list.component').then(m => m.ListComponent),
    canActivate: [...authenticatedRouteGuards, canActivateCollaborators],
    data: {
      title: 'Colaboradores',
      key: PageKey.COLLABORATORS
    }
  }
];
